export default __webpack_public_path__ + "static/footer-banner-bg-76f87268bb62eb835ec61042b26cf287.png";